<template>
  <div class="header">
    <div class="title">
      <div class="index-title">Icontech Pte. Ltd</div>
    </div>
    <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <el-menu-item index="home">Home</el-menu-item>
        <el-menu-item index="product">Product</el-menu-item>
        <el-menu-item index="knowUs">About Us</el-menu-item>
        <el-menu-item index="linkUs">Contact Us</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      activeIndex: 'home'
    }
  },
  mounted () {
    const path = this.$route.path.split('/')
    this.activeIndex = path[path.length - 1]
  },
  watch: {
    '$route.path': function (value) {
      const path = value.split('/')
      this.activeIndex = path[path.length - 1]
    }
  },
  methods: {
    handleSelect (value) {
      this.$router.push(value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .header
    position: fixed;
    top:0;
    left:0;
    z-index:5;
    height: 62px;
    background #4A81C0
    display: flex;
    padding-left: 180px
    width 100%
    line-height 62px
    .title
      color:#fff;
      font-size:24px
      display: inline-block;
      margin-right: 50px
      .index-title
        display: contents
        font 700 30px "Comic Sans MS"
        text-shadow 0 0 10px #fdec84,
          2px -2px 6px #ffae35,
          5px -3px 5px #ec760c,
          -3px -3px 3px #cd4607,
          0px -2px 2px #973717,
          1px -2px 2px #451b0e
      .logo
        font-size:20px;
        font-weight:600;
        line-height: 30px;
    .el-menu
      display: inline-block
      margin-top 16px
      background: transparent
    .el-menu--horizontal>.el-menu-item
      color: #fff;
      height: 30px;
      line-height: 30px;
      margin-right: 20px;
      border-bottom: none;
      border-radius: 5px;
    .el-menu.el-menu--horizontal
      border: none
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal>.el-submenu .el-submenu__title:hover
      background #409eff
      color: #fff
      border-bottom: none
    .el-menu--horizontal>.el-menu-item.is-active
      background: #409eff
      color: #fff
      border-bottom: none
</style>



// WEBPACK FOOTER //
// src/components/header.vue